<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div
    (cdkDragEnded)="dragEnded($event)"
    [config]="preloaderService.getLoadingConfig(loaderKey)"
    [suiIsLoading]="loaderKey"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    class="modal-window-content restorable-window preloader-wrapper"
>
    <div cdkDragHandle class="modal-header">
        <h4>PtMP Info</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>

    <div *ngIf="!historyService || !reportSectorsMap || !reportSectorsMap.size" class="modal-body">
        <h6>No PtMP sectors in this topology</h6>
    </div>

    <div *ngIf="historyService && reportSectorsMap && reportSectorsMap.size" class="modal-body modal-body--fixed-header">
        <div class="modal-body__fixed-header">
            <winde-tabs-nav
                (tabChanged)="changeTab($event)"
                *ngIf="tabsToShow && tabsToShow.length > 0"
                [activeTab]="currentTab"
                [customClass]="'tabs-nav--doc-tabs mb-1 report-tabs'"
                [tabsList]="tabsToShow"
                [translationPrefix]="'project.reportsTabs'"
            >
            </winde-tabs-nav>
        </div>

        <div #scrollContainer class="modal-body__scroll-content has-footer">
            <ul class="list-unstyled pt-3 sectors-list">
                <ng-container *ngFor="let sectorGroup of reportDataToShow; let i = index">
                    <li
                        *ngFor="let sector of sectorGroup; trackBy: trackSector; let sectorI = index"
                        class="sectors-list__item sector sector--{{ generateAggregatedSectorIndex(sector) }}"
                    >
                        <ng-container *ngIf="sector.showInDeviceSectorIndex; else defaultView">
                            <div *ngIf="sectorI === 0" class="d-inline-flex align-items-baseline">
                                <!--                              sector.sectIdx is used by e2e tests  -->
                                <h6>
                                    PtMP-Location
                                    <span [attr.data-sector-index]="sector.sectIdx" class="sector__index" style="display: none"></span>
                                </h6>
                                <strong class="sector__node-name ml-4">
                                    <winde-node-pointer
                                        [listData]="{ nodeNames: sector.nodeid, placement: 'top', cropName: 10 }"
                                    ></winde-node-pointer>
                                </strong>
                            </div>
                            <br />

                            Sector in device - <strong class="sector__iinDev">{{ sector.sectorInDevViewValue }}</strong
                            >,
                        </ng-container>

                        <ng-template #defaultView>
                            <!--                              sector.sectIdx is used by e2e tests  -->
                            <h6>
                                Sector
                                <span [attr.data-sector-index]="sector.sectIdx" class="sector__index" style="display: none"></span>
                                {{ sector.sectorIdxViewValue }}
                            </h6>
                            <strong class="sector__node-name">
                                <winde-node-pointer
                                    [listData]="{ nodeNames: sector.nodeid, placement: 'top', cropName: 10 }"
                                ></winde-node-pointer> </strong
                            >,
                        </ng-template>

                        Frequency -
                        <strong class="sector__frequency"
                            >{{ sector.txFreq === -1 ? 'not assigned' : getFrequencyChannelValue(sector.txFreq) }},</strong
                        >
                        Direction - <strong class="sector__direction">{{ sector.sectDir }}°</strong>
                        <div *ngIf="sector.sectorLinkData.length" class="grid">
                            <!-- HEADER -->
                            <div class="grid-row">
                                <div class="grid-row__cell">
                                    <div>Distance</div>
                                    <span class="font-weight-normal d-block"> ({{ historyService.logicalTopology?.productUnits }}) </span>
                                </div>
                                <div class="grid-row__cell product-cell">Product</div>
                                <div *ngIf="layers" class="grid-row__cell">Layer</div>
                                <div class="grid-row__cell">Link Identification</div>
                                <div class="grid-row__cell state-cell">Frozen / Installed</div>
                            </div>

                            <!-- BODY -->
                            <div
                                *ngFor="let link of sector.sectorLinkData; trackBy: trackLinkData"
                                [ngClass]="{ 'highlight-substring--blue': link['selected'] }"
                                class="grid-row"
                            >
                                <div class="grid-row__cell product-cell">
                                    {{ link.distance | FeetConvert: historyService.logicalTopology?.productUnits }}
                                </div>
                                <div class="grid-row__cell">
                                    {{ link.usedProductName === 'MultiHaul' ? 'MH-TU' : link.usedProductName }}
                                </div>
                                <div *ngIf="layers" class="grid-row__cell">{{ layers[link.layerIndex] }}</div>
                                <div class="grid-row__cell">
                                    <winde-node-pointer
                                        [listData]="{
                                            nodeNames: sector.nodeid === link.node0Id ? link.node1Id : link.node0Id,
                                            placement: 'top',
                                            cropName: 10
                                        }"
                                    ></winde-node-pointer>
                                </div>
                                <div class="grid-row__cell state-cell">
                                    @if (link.isUserForced && !link.isInstalled) {
                                        <button windeActionIcon>
                                            <sui-svg-icon icon="lock" windeGrey />
                                        </button>
                                    }
                                    @if (link.isUserForced && link.isInstalled) {
                                        <button windeActionIcon>
                                            <sui-svg-icon icon="podcast" windeGrey />
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </div>
        <div class="modal-footer-button">
            <button (click)="exportToExcel()" [disabled]="!reportDataToShow?.length" windeGreen>Export to Excel</button>
        </div>
    </div>
</div>
